import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Button, Spin } from 'antd';
import { login, getAccessToken } from '../../actions';
import { getQueryParam } from '../../utils/util';
import './index.less';

class Login extends PureComponent {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string.isRequired,
    }).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    login: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (!this.props.isAuthenticated) {
      const { pathname, search } = this.props.location;
      const token = getQueryParam(search, 'token');

      if (pathname === '/login/callback' && token) {
        this.props.getAccessToken(token);
      }
    }
  }

  handleLogin = () => {
    this.props.login();
  }

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/" />;
    }
    return (
      <Switch>
        <Route path="/login/callback" render={() => <div className="login"><div className="container"><Spin size="large" className="spin" /></div></div>} />
        <Route
          path="/"
          render={() => (
            <div className="login">
              <div className="container">
                <div className="content">
                  <span className="title">OVP3 Support App</span>
                  <Button loading={this.props.isAuthenticating} className="btn-login" size="large" type="primary" onClick={this.handleLogin}>Login with Azure</Button>
                </div>
              </div>
            </div>
          )}
        />
      </Switch>
    );
  }
}

function mapStateToProps({ auth }) {
  return {
    isAuthenticated: auth.isAuthenticated,
    isAuthenticating: auth.isAuthenticating,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ login, getAccessToken }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/routes/Login/index.js